/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{strict as e}from"../../core/jsonMap.js";const s=e()({year:"years",quarter:"quarters",month:"months",week:"weeks",day:"days",hour:"hours",minute:"minutes",second:"seconds"});export{s as unitsDict};
